import React, { useState, useEffect } from 'react'
import { DiventryBlock } from './Layout';
import { Empty, Card } from 'antd';
import Highcharts from 'highcharts';
import HC_exporting from 'highcharts/modules/exporting';
import HighchartsReact from 'highcharts-react-official'
import highcharts3d from "highcharts/highcharts-3d";
HC_exporting(Highcharts);
highcharts3d(Highcharts);


function Statistic({ kernel, endpoint, type, statName, statCategoryName, statTypes, title, globalStats, exclude, disabled }) {
    const [loaded, setLoaded] = useState(true)
    const [data, setData] = useState([])

    // async load
    useEffect(() => {
        async function fetchStats() {
            const raw = await kernel.api.get(`${endpoint}`)
            if (raw.error) {
                setData([]);
                return
            }

            const newData = [];

            if (type === 'pie') {
                const newPieData = [{
                    name: statName,
                    data: raw?.data?.map((item) => [item?.[statCategoryName]?.tag, item?.values?.reduce((acc, val) => acc + val[1], 0)])
                    // data: Object.keys(raw?.data?.[statCategoryName]).map((stat, index) => ([raw?.data?.[statCategoryName]?.[stat], raw.data.values?.reduce((acc, item) => acc + item[index + 1], 0)]))
                }]
                setData(newPieData);
            } else {
                Object.keys(statTypes).forEach((stat, index) => {
                    newData.push({
                        name: stat,
                        data: raw.data.values?.map(item => ([new Date(item[0]).getTime(), item[index + 1]])),
                        step: true,
                        color: statTypes?.[stat],
                        visible: !disabled?.includes(stat) ?? true
                    })
                });
                setData(newData)
            }
        }

        fetchStats()
    }, [loaded, endpoint])


    var options;
    switch (type) {
        case 'line':
            options = {
                xAxis: {
                    categories: data?.[0]?.data?.map(item => item?.[0]),
                    allowDecimals: false,
                    labels: {
                        step: 20
                    }
                },
                title: {
                    text: title
                },
                credits: {
                    enabled: false
                },
                plotOptions: {
                    line: {
                        marker: {
                            enabled: false
                        }
                    }
                },
                title: {
                    text: null
                },
                yAxis: {
                    title: {
                        text: ''
                    }
                },
                credits: {
                    enabled: false
                },
                series: data
            };
            break;


        case 'area':
            options = {
                chart: {
                    type: 'line'
                },
                title: null,
                xAxis: {
                    type: 'datetime',
                },
                yAxis: {
                    title: {
                        text: 'Request'
                    }
                },
                legend: {
                    align: 'left',
                    verticalAlign: 'top',
                    borderWidth: 0
                },

                tooltip: {
                    shared: true,
                    crosshairs: true
                },
                plotOptions: {
                    area: {
                        fillOpacity: 0
                    }
                },
                exporting: {
                    enabled: false
                },
                credits: {
                    enabled: false
                },
                series: data?.filter((stat) => !exclude?.includes(stat?.name)/*  && stat?.name != 'bypassing' */)
            };
            break;

        case 'pie':

            options = {
                chart: {
                    type: 'pie',
                    options3d: {
                        enabled: true,
                        alpha: 45
                    }
                },
                // colors: ['blue', '#FFE0FF', '#0F0FF0', '#FFFF00', '#FFF000',
                //     '#FF0000', '#F000F0', '#00EFF0', '#c42525', '#a6c96a'],
                title: {
                    text: '',
                    align: 'left'
                },
                subtitle: {
                    text: '',
                    align: 'left'
                },
                exporting: {
                    enabled: false
                },
                plotOptions: {
                    pie: {
                        // innerSize: 100,
                        depth: 45
                    }
                },
                credits: {
                    enabled: false
                },
                series: data,
            };

            break;

        default:
            break;
    }


    return <>
        <DiventryBlock>
            {data.length === 0 ? <Empty /> :
                <HighchartsReact highcharts={Highcharts} options={options} />
            }
        </DiventryBlock>
    </>
}

export default Statistic


const styles = {
    filters: {
        margin: '10px 0'
    },
    statContainer: {
        marginTop: 5,
        marginBottom: 5,
        textAlign: 'center'
    },
    statName: {
        marginBottom: '-0.2em',
        fontWeight: 800
    },
    statValue: {
        color: '#777777',
        fontSize: '18px'
    }
}